export default "__VITE_ASSET__BjItiUJJ__"